import { queryBuilderConfig } from '@kentik/ui-shared/dictionary/content/queryBuilderConfig';
import { DictionaryRuntime } from '@kentik/ui-shared/dictionary/types';

export const cutFields = [
  'c_dst_dns_query',
  'c_src_dns_query',
  'ktappprotocol__dns__STR00',
  'ktappprotocol__dns__STR01',
  'ktappprotocol__dhcp__STR01',
  'ktappprotocol__dhcp__STR02',
  'ktappprotocol__http__STR01',
  'ktappprotocol__tls__STR00',
  'ktappprotocol__http__STR00',
  'ktappprotocol__http__STR02'
];

export function getCutFnFields() {
  const additionalCutFields: string[] = [];

  for (const [fieldName, { allowsCut }] of Object.entries(queryBuilderConfig)) {
    if (allowsCut) {
      additionalCutFields.push(fieldName);
    }
  }

  return new Set([...cutFields, ...additionalCutFields]);
}

export default function addCutFnFields(dictionary: DictionaryRuntime) {
  return { ...dictionary, cutFn: { ...dictionary.cutFn, fields: [...getCutFnFields()] } };
}
